export type BrokerNerdsBarkerCoreEnumsAdjustmentType = (typeof BrokerNerdsBarkerCoreEnumsAdjustmentType)[keyof typeof BrokerNerdsBarkerCoreEnumsAdjustmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsAdjustmentType = {
  Amount: 'Amount',
  Percentage: 'Percentage',
} as const;
